import axios from 'axios';
import { API } from '../../../config/api';

const http = axios.create({
  baseURL: API.BACKEND,
  timeout: 120000 // 2min for AI parsing
});

http.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers['x-auth-token'] = token;
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
});

export async function parsePackingList(file) {
  const formData = new FormData();
  formData.append('file', file);
  const { data } = await http.post('/api/v1/raw-materials/parse', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return data;
}

export async function createRawMaterials(items) {
  const { data } = await http.post('/api/v1/raw-materials', { items });
  return data;
}

export async function fetchRawMaterials(params = {}) {
  const { data } = await http.get('/api/v1/raw-materials', { params });
  return data;
}

export async function fetchRawMaterial(id) {
  const { data } = await http.get(`/api/v1/raw-materials/${id}`);
  return data;
}

export async function updateRawMaterial({ id, ...payload }) {
  const { data } = await http.patch(`/api/v1/raw-materials/${id}`, payload);
  return data;
}

export async function deleteRawMaterial(id) {
  const { data } = await http.delete(`/api/v1/raw-materials/${id}`);
  return data;
}

export async function deleteManyRawMaterials(ids) {
  const { data } = await http.post('/api/v1/raw-materials/delete-many', { ids });
  return data;
}

export async function assignRawMaterial({ id, jobId, taskId, machineId }) {
  const { data } = await http.post(`/api/v1/raw-materials/${id}/assign`, {
    jobId, taskId, machineId
  });
  return data;
}

export async function releaseRawMaterial({ id, remainingWeight, tokenId, lengthProduced }) {
  const { data } = await http.post(`/api/v1/raw-materials/${id}/release`, {
    remainingWeight, tokenId, lengthProduced
  });
  return data;
}
